<template>
    <div>
      <div class="action-buttons">
        <div class="left-buttons">
          <div class="form-group mar-rt-10" style="max-width: 230px;">
            <label>{{ $t('gestiune.locatie') }}</label>
            <select class="form-control" v-model="selectedVatNumber">
              <option :value="null">Selectează</option>
              <option
                v-for="group in groupedLocations"
                :key="group.vat"
                :value="group.vat"
              >
                VAT: {{ group.vat }} — {{ group.locations.map(l => l.name).join(', ') }}
              </option>
            </select>
          </div>
          <div class="form-group mar-rt-10" style="max-width: 230px;">
            <label for="searchInput">{{ $t('gestiune.searchSuppliers') }}</label>
            <el-input
                id="searchInput"
                v-model="searchQuery"
                placeholder="Caută după nume distribuitor"
                clearable
            ></el-input>
          </div>
          <div class="search-button-reports">
            <button
                :title="$t('reports.search')"
                class="btn add mar-rt-10"
                @click="onSearch"
            >
                <i class="ti-search"></i>
                <span>{{ $t('general.search') }}</span>
            </button>
          </div>
         </div>
         <div class="right-buttons">
            <button class="btn add mar-rt-10"  @click.prevent="openAddSupplierModal" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
              <img src="/static/img/icons/add.png">
              {{ $t('gestiune.addSupplier') }}
            </button>
         </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="data-table">
              <el-table :data="filteredSuppliers" :empty-text="$t('gestiune.noData')">
                  <el-table-column prop="distributorName" :label="$t('gestiune.distributorName')"></el-table-column>
                  <el-table-column prop="address" :label="$t('gestiune.address')"></el-table-column>
                  <el-table-column prop="cui" :label="$t('gestiune.cui')"></el-table-column>
                  <el-table-column :label="$t('marketingOffers.actions')" width="100">
                    <template slot-scope="scope">
                      <el-dropdown trigger="click" placement="bottom-end">
                        <!-- Trigger: săgeată jos cu border violet -->
                        <span class="arrow-box">
                          &#9662;
                        </span>

                        <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                          <el-dropdown-item @click.native="editRow(scope.row)">
                            {{$t('general.edit')}}
                          </el-dropdown-item>

                          <el-dropdown-item @click.native="handleDelete(scope.row.id)"
                            style="color: red; font-weight: bold;">
                            {{$t('general.delete')}}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
              </el-table>
              <el-pagination
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handlePageChange"
                style="margin-top: 15px; text-align: right;"
              ></el-pagination>
          </div>
        </div>
     </div>

     <ManagementSuppliersAdd
      :groupedLocations="groupedLocations"
      :getSuppliers="getSuppliers"
      :supplierData="supplier"
      :editMode="editMode"
      :filterVatNumber="selectedVatNumber"
      @getSuppliers="getSuppliers"
    />
    </div>
</template>

  <script>
    import swal from 'sweetalert2'
    import ManagementSuppliersAdd from './ManagementSuppliersAdd.vue'

    export default {
      components: {
        ManagementSuppliersAdd
      },
      data () {
        return {
          loading: true,
          loadingTimeout: null,
          totalItems: 0,
          currentPage: 1,
          pageSize: 20,
          tableData: [],
          selectedVatNumber: null,
          selectedLocationId: '',
          selectedLocation: null,
          vatNumber: null,
          editMode: false,
          supplier: {
            companyName: '',
            abbreviation: '',
            CUI: '',
            registrationNumber: '',
            email: '',
            address: '',
            bank: '',
            IBAN: '',
            dueDays: null
          },
          searchQuery: ''
        }
      },
      props: {
        groupedLocations: {
          type: Array,
          required: true
        }
      },
      watch: {
        selectedLocationId (id) {
          for (const group of this.groupedLocations) {
            const loc = group.locations.find(l => l.true_id === id)
            if (loc) {
              this.selectedLocation = loc
              break
            }
          }
        },
        selectedVatNumber (newVat) {
          this.selectedVatNumber = newVat
        }
      },
      created () {
        this.companyID = this.$session.get('selectedCompany')
      },
      computed: {
        filteredSuppliers () {
          if (!this.searchQuery) {
            return this.tableData
          }

          return this.tableData.filter(supplier => {
            return supplier.distributorName.toLowerCase().includes(this.searchQuery.toLowerCase())
          })
        }
      },
      methods: {
        onSearch () {
          // Validare cod TVA
          if (!this.selectedVatNumber) {
            swal({
              type: 'warning',
              title: this.$t('general.required'),
              text: 'Selectateaza locatiați după cod TVA',
              confirmButtonText: 'OK'
            })

            this.tableData = []
            this.totalItems = 0
            this.currentPage = 1

            return
          }

          // Apelăm fetch-ul efectiv
          this.getSuppliers()
        },
        handlePageChange (page) {
          this.currentPage = page
          this.getSuppliers(this.currentPage, this.pageSize)
        },
        openAddSupplierModal () {
          this.editMode = false
          this.supplier = {
            companyName: '',
            abbreviation: '',
            CUI: '',
            email: '',
            registrationNumber: '',
            address: '',
            bank: '',
            IBAN: '',
            dueDays: null,
            id: null,
            _rev: null
          }
          this.$modal.show('addSupplierModal')
        },
        editRow (row) {
          this.editMode = true
          this.supplier = this.mapSupplierRowToForm({
            ...row,
            vatNumber: row.vatNumber || this.selectedVatNumber || ''
          })
          this.$modal.show('addSupplierModal')
        },
        mapSupplierRowToForm (row = {}) {
          return {
            companyName: row.companyName || row.distributorName || row.name || '',
            abbreviation: row.abbreviation || '',
            CUI: row.CUI || row.cui || row.supplierVatNumber || '',
            email: row.email || '',
            registrationNumber: row.registrationNumber || '',
            address: row.address || '',
            bank: row.bank || '',
            IBAN: row.IBAN || row.iban || '',
            dueDays: row.dueDays != null ? row.dueDays : null,
            id: row.id || row._id || null,
            _rev: row._rev || null,
            externalLocationId: row.externalLocationId || null,
            vatNumber: row.vatNumber || this.selectedVatNumber || null
          }
        },
        async getSuppliers (page = 1, pageSize = 25) {
          this.tableData = []
          this.totalItems = 0
          this.currentPage = 1

          try {
            if (!this.companyID) {
              console.error('Company ID is missing')
              return
            }

            if (!this.selectedVatNumber) {
              console.warn('VAT number is missing. Skipping product fetch.')
              return
            }

            swal({
              title: 'Se încarcă...',
              text: 'Așteaptă încărcarea datelor',
              allowOutsideClick: false,
              didOpen: () => {
                swal.showLoading()
              }
            })

            clearTimeout(this.loadingTimeout)
            this.loadingTimeout = setTimeout(() => {
              this.loading = true
            }, 100)

            // Inițializează URL-ul de bază
            let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/suppliers?externalCompanyId=${this.companyID}&page=${page}&limit=${pageSize}`

            if (this.selectedVatNumber) {
              url += `&vatNumber=${encodeURIComponent(this.selectedVatNumber)}`
            }

            const response = await fetch(url)

            if (!response.ok) {
              throw new Error('Error fetching suppliers')
            }

            const data = await response.json()
            if (!data.suppliers || !Array.isArray(data.suppliers)) {
              throw new Error('Invalid data format: suppliers not found')
            }

            clearTimeout(this.loadingTimeout)
            this.loading = false
            this.totalItems = data.total || 0
            this.currentPage = data.currentPage || page
            this.pageSize = data.pageSize || pageSize

            this.tableData = data.suppliers.map(supplier => ({
              id: supplier._id,
              _rev: supplier._rev,
              distributorName: supplier.name,
              address: supplier.address || '',
              cui: supplier.supplierVatNumber || '',
              supplierVatNumber: supplier.supplierVatNumber || '',
              email: supplier.email || '',
              companyName: supplier.name || '',
              abbreviation: supplier.abbreviation || '',
              registrationNumber: supplier.registrationNumber || '',
              bank: supplier.bank || '',
              IBAN: supplier.IBAN || supplier.iban || '',
              dueDays: supplier.dueDays != null ? supplier.dueDays : null,
              vatNumber: supplier.vatNumber || this.selectedVatNumber || '',
              externalLocationId: supplier.externalLocationId || null
            }))

            swal.close()
          } catch (error) {
            swal.close()
            console.error('Error fetching suppliers:', error)
          }
        },
        async handleDelete (id) {
          if (!id) {
            console.error('Missing product ID for deletion.')
            return
          }

          const confirm = await swal({
            title: 'Ești sigur?',
            text: 'Furnizorul va fi șters definitiv.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Da, șterge',
            cancelButtonText: 'Anulează'
          })

          if (!confirm) return

          try {
            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/remove`, {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'supplier',
                id: id,
                externalCompanyId: this.companyID
              })
            })

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

            const data = await response.json()
            console.log('Supplier deleted successfully:', data)

            swal({
              title: 'Succes',
              text: 'Furnizorul a fost șters cu succes.',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })

            this.getSuppliers()
          } catch (error) {
            console.error('Error deleting supplier:', error)

            swal({
              title: 'Eroare',
              text: 'A apărut o eroare la ștergerea furnizorului.',
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        }
      }
    }
  </script>

<style scoped>
.arrow-box {
  display: inline-block;
  font-size: 18px; /* mărimea săgeții */
  padding: 4px 6px;
  border: 1px solid #674BD2 !important; /* border violet */
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2; /* culoarea săgeții */
}

.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important; /* săgeata albă la hover */
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}
.el-pagination {
  text-align: center !important;
}
.left-buttons {
  display: flex;
  align-items: center;
}
.search {
  display: flex;
  flex-direction: column;
}
.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}
.button-group {
    display: flex; /* Folosește flexbox pentru alinierea orizontală */
    justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Suppliers/ManagementSuppliers.vue